import PropTypes from 'prop-types';
import { isLexReceptionUKBrand, isAnswerConnectCABrand, isAnswerConnectUKBrand } from '../../helpers/brands';
import { GCrossIcon } from '../../app/icons/common-icons';
import { SuspenseWrapper, getTermsComponentContent } from '../../helpers/dynamic-import-helper';
import PopupContentLoader from '../PopupcontentLoader';

const TermsContent = getTermsComponentContent();
export default function TermsModal(props) {
  let titleContent = 'Terms and Conditions';

  if (isLexReceptionUKBrand || isAnswerConnectUKBrand) {
    titleContent = 'Terms and Conditions of Supply';
  } else if (isAnswerConnectCABrand) {
    titleContent = 'Terms of Service';
  }

  return (
    <div className="g-modal-window">
      <div className="g-modal-wrapper alternate policy-modal">
        <header className="g-modal-head">
          <h4 className={`title ${isAnswerConnectUKBrand ? 'tc-primary' : ''} ${isLexReceptionUKBrand && 'heading-md'}`}>{titleContent}</h4>
          <button data-testid="termsModalCloseBtn" type="button" className="nostyle g-modal-close" onClick={props.onClose}>
            <GCrossIcon />
          </button>
        </header>
        <SuspenseWrapper fallback={<PopupContentLoader />}>
          <TermsContent isHIPAA={props.isHIPAA}/>
        </SuspenseWrapper>
      </div>
    </div>
  );
}

TermsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isHIPAA: PropTypes.bool,
};

TermsContent.defaultProps = {
  isHIPAA: false,
};
